function useCaptcha() {
  const { currentLanguage } = useMagnoliaLanguage();

  const captchaLanguage = computed(() => {
    return currentLanguage.value.split("-")[0];
  });

  const captchaSolution = useState("captchaSolution", () => "");

  const {
    public: {
      friendlyCaptcha: { siteKey },
    },
  } = useRuntimeConfig();

  return { captchaSolution, captchaLanguage, siteKey };
}

export default createSharedComposable(useCaptcha);
